export default "__VITE_ASSET__q_lKhZPb__"